import React, { Fragment } from 'react'
import classnames from 'classnames'
import Star from '../../../../assets/img/Ico_Star.png'
import NoMealImage from '../../../../assets/img/no-image.png'
import './MealCard.css'

const MealCard = ({ mealDetail, toggleChefDetail, isLoading }) => {
  return (
    <section className="card-container">
      <section className="slider-container">
        {isLoading ? (
          <div className="slider-img loading" />
        ) : mealDetail && mealDetail.imageFullUrl ? (
          <div
            style={{ backgroundImage: `url(${mealDetail.imageFullUrl})` }}
            className="slider-img"
          />
        ) : (
          <div
            style={{ backgroundImage: `url(${NoMealImage})` }}
            className="slider-no-img slider-img">
            <p className="txt-noimage">Image coming soon</p>
          </div>
        )}
      </section>
      <section className="meal-info">
        <h2
          className={classnames('title', {
            loading: isLoading
          })}>
          {mealDetail.name}
        </h2>
        <p
          className={classnames('title-with', {
            loading: isLoading
          })}>
          {mealDetail.short_description}
        </p>

        <div
          className={classnames('review-count-container', {
            loading: isLoading
          })}>
          <img src={Star} alt="star" />
          <span className="total-star">
            {parseFloat(+mealDetail.stars || 0).toFixed(2)}
          </span>
          {mealDetail.reviews && (
            <Fragment>
              <span className="separator">|</span>
              <span className="total-reviews">
                {mealDetail.reviews.length || 0} reviews{' '}
              </span>
            </Fragment>
          )}
          {/* {mealDetail.user_rating && (
            <Fragment>
              <span className="dot">·</span>
              <span className="user_rating">
                You rated it <img src={Star} alt="star" />{' '}
                <span>
                  {parseFloat(+mealDetail.user_rating || 0).toFixed(2)}
                </span>
              </span>
            </Fragment>
          )} */}
        </div>

        <div className="chef">
          <a
            onClick={() => {
              if (!isLoading) {
                toggleChefDetail(mealDetail.chef_id)
              }
            }}>
            {isLoading ? (
              <div className="chef-img loading" />
            ) : (
              <div
                className="chef-img"
                style={{ backgroundImage: `url(${mealDetail.chef_img})` }}
              />
            )}
            <p
              className={classnames({
                loading: isLoading
              })}>
              by
              <span>
                {' '}
                {mealDetail.chef_firstname} {mealDetail.chef_lastname}
              </span>
            </p>
          </a>
        </div>
        <p
          className={classnames('story-meal', {
            loading: isLoading
          })}>
          {mealDetail.meal_story}
        </p>
      </section>
    </section>
  )
}

export default MealCard



// WEBPACK FOOTER //
// ./src/modules/MealDetail/components/MealCard/index.js